import React from "react";
import { FormGroup, Label } from "reactstrap";
import PropTypes from "prop-types";
import Select from "react-dropdown-select";

const SearhDropDown = ({
    label,
    options,
    multi,
    searchable,
    style,
    disabled = false,
    labelField,
    valueField,
    addPlaceholder,
    placeholder,
    onChange,
    values,
    className
}) => {
    return (
        <FormGroup>
            {label && <Label>{label}</Label>}
            <Select
                multi={multi}
                options={options}
                placeholder={placeholder}
                addPlaceholder={addPlaceholder}
                searchable={searchable}
                disabled={disabled}
                labelField={labelField}
                valueField={valueField}
                values={values}
                style={style}
                onChange={onChange}
                className={className}
            />
        </FormGroup>
    );
};

export default SearhDropDown;

SearhDropDown.propTypes = {
    label: PropTypes.string,
    multi: PropTypes.bool,
    options: PropTypes.array,
    placeholder: PropTypes.string,
    searchable: PropTypes.bool,
    disabled: PropTypes.bool,
    labelField: PropTypes.string,
    valueField: PropTypes.string,
    addPlaceholder: PropTypes.string,
    onChange: PropTypes.func,
    values: PropTypes.array,
    className: PropTypes.string,
    style: PropTypes.object
}